import { render, staticRenderFns } from "./SpecTable.vue?vue&type=template&id=8fae5916&scoped=true&lang=pug&"
import script from "./SpecTable.vue?vue&type=script&lang=js&"
export * from "./SpecTable.vue?vue&type=script&lang=js&"
import style0 from "./SpecTable.vue?vue&type=style&index=0&id=8fae5916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fae5916",
  null
  
)

export default component.exports